import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { unpack_validation } from 'webui/Z3KConfigParser/validation/types';
import { Schedule } from './schedule';
const ScheduleCard = memo(function ScheduleCard(props) {
    const { state, validation, onChangeTabState } = props;
    const { circuit, timetable, time_intervals, start_times, end_times, heating_modes } = state;
    if (timetable == null) {
        return null;
    }
    return (_jsx(Schedule, { circuit_id: circuit.id, timetable: timetable, time_intervals: time_intervals, start_times: start_times, end_times: end_times, start_times_validation: unpack_validation(validation, 'start_times'), end_times_validation: unpack_validation(validation, 'end_times'), heating_modes: heating_modes, onChangeTabState: onChangeTabState }));
});
export { ScheduleCard };
